export enum VildMappingColor {
  VILD = '#ee8822',
  VILD_END_NEG = 'red',
  VILD_END_POS = 'red',
  VILD_SELECTED = 'purple',
  VILD_START_NEG = 'green',
  VILD_START_POS = 'green',
  OSM = 'black',
  OSM_HIGHLIGHT = 'yellow',
  OSM_MAPPED_POS = 'green',
  OSM_MAPPED_NEG = 'red'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/vildmapping-color.ts